export default __webpack_public_path__ + "static/media/02__o_preview_2.abcaaf3d.jpg";